import PropTypes from 'prop-types';
import { Component } from 'react';

import Formsy from 'formsy-react';
import { SheetBody, SheetFooter, Row, Col, Button, Label, FormGroup } from 'twyne-new.ui'

import Input from 'components/form/Input';
import Switch from 'components/form/Switch';
import siteStore from 'modules/admin/stores/site';
import { LOADED } from 'stores/BaseStore';
import history from 'utils/history';

export default class PublisherForm extends Component {
  state = {
    active: true,
  }

  loadData() {
    const siteLocalStoragee = JSON.parse(localStorage.getItem('site'));
    const { id } = siteLocalStoragee;
    if (id) {
      siteStore.fetch(id);
    }
  }

  componentWillMount() {
    const { data } = this.props;
    if (data) {
      this.setState(data);
    }
    this.loadData();
  }

  handleValidSubmit = model => {
    this.props.handleSubmit({
      ...this.state,
      ...model,
    });
  }

  handleCancel = () => {
    if (this.props.onCancel) {
      this.props.onCancel();
    } else {
      history.goBack();
    }
  }

  ThrottlingOverrideToggle = ({ children }) => <Col size='10'>
    <FormGroup>
      <Label>Override Throttling</Label><br />
      {children}
    </FormGroup>
  </Col>

  render() {
    return (
      <Formsy onValidSubmit={this.handleValidSubmit}>
        <SheetBody>
          <Row>
            <Col size="12">
              <FormGroup>
                <Label>Name</Label>
                <Input name="name" value={this.state.name || ''} required />
              </FormGroup>
            </Col>
            <Col size="12">
              <FormGroup>
                <Label>External-ID Key</Label>
                <Input name="external_id" value={this.state.external_id || ''} />
              </FormGroup>
            </Col>
            <Col size="2">
              <FormGroup>
                <Label>Active</Label>
                <Switch name="active" value={this.state.active || false} />
              </FormGroup>
            </Col>
          </Row>
        </SheetBody>
        <SheetFooter>
          <Button onClick={this.handleCancel} variant='ghost'>Cancel</Button>
          <Button type="submit" color="accent">Save</Button>
        </SheetFooter>
      </Formsy>
    )
  }
}

PublisherForm.propTypes = {
  handleSubmit: PropTypes.func,
  data: PropTypes.any,
};
